





























































































import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useRouter } from '../router';
import { getStore } from '../store';

const componentName = 'UserDashboard';

export default defineComponent({
    name: componentName,

    setup() {
        const store = getStore(), { router } = useRouter();

        const state = reactive({
            signOutErrorNotification: false,
            signOutProgress: false
        });

        const user = computed(() => store.state.loggedUser);

        const plants = computed(() => store.state.userPlants);

        const onSignOut = async () => {
            state.signOutErrorNotification = false;
            state.signOutProgress = true;

            let res = await store.dispatch('signOut');

            state.signOutProgress = false;

            if (res) {
                router.replace({ name: 'access-signin'});
            }
            else {
                state.signOutErrorNotification = true;
            }
        };

        const onDeleteAccountClick = () => {
            router.push({ name: 'user-delete', query: router.currentRoute.query });
        }

        return {
            state,
            user,
            plants,

            onSignOut,
            onDeleteAccountClick
        };
    },
});
